import { isLocalDev } from './config';

export const triggerRedirect = (path: string) => {
  const isDev = isLocalDev();
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log(`Redirect to ${path} prevented in dev environment.`);
    return false;
  }
  if (typeof window !== 'undefined') {
    window.location.href = path;
  }
  return true;
};
